import React, { useEffect, useMemo, useState } from "react";
import { Dropdown } from "react-bootstrap";
import styles from "./index.module.scss";

function PrescriptionDropDown({
  defaultPlaceH,
  defaultValue,
  DataItem,
  onChange,
  value,
  className,
  disabled,
}) {
  const [selected, setSelected] = useState(defaultValue);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleOnClick = (item) => {
    setSelected(item);
    onChange(item);
  };

  let getDisplayValue = () => {
    return value ? (
      <span>{value}</span>
    ) : value === "" ? (
      <span className={styles.placeholder}>{defaultPlaceH}</span>
    ) : (
      <span className={styles.placeholder}>{defaultPlaceH}</span>
    );
  };

  return (
    <Dropdown aria-readonly={disabled} className={`${styles.CustomDropDown} ${className}`}>
      <Dropdown.Toggle id="dropdown-basic">{getDisplayValue()}</Dropdown.Toggle>
      <Dropdown.Menu>
        {DataItem?.map((item, index) => {
          return (
            <Dropdown.Item
              key={index}
              className={value === item && styles.selectedItem}
              onClick={() => {
                handleOnClick(item);
              }}
            >
              {item}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default PrescriptionDropDown;